import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import ConsoleStore from '../../stores/ConsoleStore';
import UDSpinner from '../UD/Fragments/UDSpinner';
import './ConsoleFeatures.css';

const block = b.lock('ConsoleFeatures');

class ConsoleFeatures extends Component {
    static propTypes = {
        console: ConsoleStore.PropType.isRequired,
    };

    componentWillMount() {
        this.props.console.loadPBUrl();
    }

    render() {
        const url = this.props.console.productBoardFrameUrl;
        return <div className={block()}>
            <UDSpinner className={block('Loader')} type="large" />
            {url ? <iframe
                key={url}
                className={block('Frame')}
                title="Product Board"
                src={url}
            /> : null}
        </div>;
    }
}

export default inject('console')(observer(ConsoleFeatures));
